import React, { useState } from 'react';

const AIFeedback = ({ handleFeedback, liked, disliked, summaryRef }) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = () => {
        if (summaryRef && summaryRef.current) {
            navigator.clipboard.writeText(summaryRef.current.textContent);

            setCopied(true);

            setTimeout(() => {
                setCopied(false);
            }, 2000);
        }
    };

    return (
        <div className='feedback-interaction'>
            <span>Was this helpful?</span>
            <button 
                onClick={() => handleFeedback('positive')}
                className={liked ? 'active' : ''}
                title={liked ? "Liked" : "Helpful"}
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <mask id="mask0_18237_626" style={{maskType:"alpha"}} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                        <rect width="24" height="24" fill="#D9D9D9"/>
                    </mask>
                    <g mask="url(#mask0_18237_626)">
                        <path d="M18 21H7V8L14 1L15.25 2.25C15.3667 2.36667 15.4625 2.525 15.5375 2.725C15.6125 2.925 15.65 3.11667 15.65 3.3V3.65L14.55 8H21C21.5333 8 22 8.2 22.4 8.6C22.8 9 23 9.46667 23 10V12C23 12.1167 22.9833 12.2417 22.95 12.375C22.9167 12.5083 22.8833 12.6333 22.85 12.75L19.85 19.8C19.7 20.1333 19.45 20.4167 19.1 20.65C18.75 20.8833 18.3833 21 18 21ZM9 19H18L21 12V10H12L13.35 4.5L9 8.85V19ZM7 8V10H4V19H7V21H2V8H7Z" fill={liked ? "#006AD6" : "#757575"}/>
                    </g>
                </svg>
            </button>
            <button 
                onClick={() => handleFeedback('negative')}
                className={disliked ? 'active' : ''}
                title={disliked ? "Disliked" : "Not helpful"}
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <mask id="mask0_18237_629" style={{maskType:"alpha"}} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                        <rect width="24" height="24" fill="#D9D9D9"/>
                    </mask>
                    <g mask="url(#mask0_18237_629)">
                        <path d="M6 3H17V16L10 23L8.75 21.75C8.63333 21.6333 8.5375 21.475 8.4625 21.275C8.3875 21.075 8.35 20.8833 8.35 20.7V20.35L9.45 16H3C2.46667 16 2 15.8 1.6 15.4C1.2 15 1 14.5333 1 14V12C1 11.8833 1.01667 11.7583 1.05 11.625C1.08333 11.4917 1.11667 11.3667 1.15 11.25L4.15 4.2C4.3 3.86667 4.55 3.58333 4.9 3.35C5.25 3.11667 5.61667 3 6 3ZM15 5H6L3 12V14H12L10.65 19.5L15 15.15V5ZM17 16V14H20V5H17V3H22V16H17Z" fill={disliked ? "#006AD6" : "#757575"}/>
                    </g>
                </svg>
            </button>
            <button
                className="message-action-btn"
                onClick={handleCopy}
                data-tooltip={copied ? "Copied!" : "Copy"}
            >
                {copied ? (
                    <img src="/wp-content/themes/dom/assets/img/Tick.svg" alt="Copied" style={{ width: '18px', height: '18px' }} />
                ) : (
                    <svg width="24" height="24" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <mask id="mask0_19543_2077" style={{maskType: "alpha"}} maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18">
                            <rect width="24" height="24" fill="#757575"/>
                        </mask>
                        <g mask="url(#mask0_19543_2077)">
                            <path d="M6.74922 13.4969C6.37797 13.4969 6.06016 13.3647 5.79578 13.1003C5.53141 12.8359 5.39922 12.5181 5.39922 12.1469V3.14687C5.39922 2.77562 5.53141 2.45781 5.79578 2.19344C6.06016 1.92906 6.37797 1.79688 6.74922 1.79688H13.9492C14.3205 1.79688 14.6383 1.92906 14.9027 2.19344C15.167 2.45781 15.2992 2.77562 15.2992 3.14687V12.1469C15.2992 12.5181 15.167 12.8359 14.9027 13.1003C14.6383 13.3647 14.3205 13.4969 13.9492 13.4969H6.74922ZM6.74922 12.1469H13.9492V3.14687H6.74922V12.1469ZM4.04922 16.1969C3.67797 16.1969 3.36016 16.0647 3.09578 15.8003C2.83141 15.5359 2.69922 15.2181 2.69922 14.8469V5.17188C2.69922 4.98062 2.76353 4.82031 2.89216 4.69094C3.02078 4.56156 3.18016 4.49687 3.37028 4.49687C3.56041 4.49687 3.72109 4.56156 3.85234 4.69094C3.98359 4.82031 4.04922 4.98062 4.04922 5.17188V14.8469H11.9242C12.1155 14.8469 12.2758 14.9112 12.4052 15.0398C12.5345 15.1684 12.5992 15.3278 12.5992 15.5179C12.5992 15.7081 12.5345 15.8687 12.4052 16C12.2758 16.1312 12.1155 16.1969 11.9242 16.1969H4.04922Z" fill="#757575"/>
                        </g>
                    </svg>
                )}
            </button>
        </div>
    );
};

export default AIFeedback;
